import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClCheckbox } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-checkbox',
    templateUrl: './form-checkbox.component.html',
    styleUrls: ['./form-checkbox.component.css'],
    imports: [ReactiveFormsModule, ClCheckbox, ErrorComponent],
})
export class FormCheckboxComponent {
    readonly control = input.required<FormControl<boolean>>();
    readonly label = input.required<string>();
    readonly inputId = input.required<string>();
}
